export function responseToError(responseData: any) {
  console.log("download response:", responseData);
  const { status_code, data_path } = responseData;
  if (status_code === 200 && data_path) {
    return data_path; // 返回用到的是data_path
  } else {
    return Promise.reject(data_path);
  }
}
